import { StoreState } from '@/redux/types';
import { selectBasket } from './selectBasket';

export const selectBasketItems = (state: StoreState) => selectBasket(state).items || [];
